import React from 'react';
export const BroadcastEmailModalHeader = () => {
  return <>Managed Email Broadcast</>;
};